import { render } from "./Price.vue?vue&type=template&id=a3c671fc&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"

import "@/assets/css/mypage.css?vue&type=style&index=0&id=a3c671fc&scoped=true&lang=css&external"
import "./Price.vue?vue&type=style&index=1&id=a3c671fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3c671fc"]])

export default __exports__